"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const classnames_1 = __importDefault(require("classnames"));
const immutable_1 = require("immutable");
const formik_1 = require("formik");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const luxon_1 = require("luxon");
const uuid_1 = require("uuid");
const lodash_1 = require("lodash");
const mui_1 = require("tss-react/mui");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogContentText_1 = __importDefault(require("@mui/material/DialogContentText"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const CallSplit_1 = __importDefault(require("@mui/icons-material/CallSplit"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const scheduledTransactionsUtils_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsUtils");
const scheduledTransactionsActions_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsActions");
const scheduledTransactionsTypes_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsTypes");
const transactionsTransformers_1 = require("companion-app-components/flux/transactions/transactionsTransformers");
const transactions_1 = require("companion-app-components/flux/transactions");
const categories_1 = require("companion-app-components/flux/categories");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const auth_1 = require("companion-app-components/flux/auth");
const config_feature_flags_1 = require("companion-app-components/flux/config-feature-flags");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const QButton_1 = __importDefault(require("components/QButton"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const AccountField_1 = __importDefault(require("components/QuickenControls/AccountField"));
const SplitsAndDetailsPanel_1 = __importDefault(require("components/SplitsAndDetailsPanel"));
const AmountField_1 = require("components/QuickenControls/AmountField");
const DownshiftField_1 = __importDefault(require("components/QuickenControls/DownshiftField"));
const constants_1 = require("utils/constants");
const clientConfigFlags_1 = require("utils/clientConfigFlags");
const utils_1 = require("data/transactions/utils");
const icon_delete_black_svg_1 = __importDefault(require("assets/icon-delete-black.svg"));
const ConfirmationDialog_1 = require("../../Dialogs/ConfirmationDialog");
const styles_1 = __importDefault(require("./styles"));
const utils_2 = require("./utils");
const RecrAmountField_1 = __importDefault(require("./RecrAmountField"));
const RecrVirtualField_1 = __importDefault(require("./RecrVirtualField"));
const RecrCategoryField_1 = __importDefault(require("./RecrCategoryField"));
const RecrTagField_1 = __importDefault(require("./RecrTagField"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const ScheduledTransactionFormQuicken = ({ scheduledTransaction, selectedTab, label, isConfirmationDialogOpen, isFormDirty, setDirtyForm, discardCb, onSubmit, onClose, showConfirmationDialog, showCloseButton, changeDetailsMode, deleteUserVerificationFromPayload, hideDeleteIcon, }) => {
    const { classes } = useStyles();
    const isQWinDataset = (0, react_redux_1.useSelector)(auth_1.authSelectors.getIsWinDataset);
    const personalIncomeCategory = (0, react_redux_1.useSelector)(categories_1.categoriesSelectors.getPersonalIncomeCategory);
    const showScheduledTxnDayFrequency = (0, react_redux_1.useSelector)((state) => config_feature_flags_1.configFeatureFlagsSelectors.getFeatureFlagForUserOrDataset(state, clientConfigFlags_1.ClientConfigFlags.showScheduledTxnDayFrequency));
    const dispatch = (0, react_redux_1.useDispatch)();
    const dispatchCreateScheduledTransactionAction = (data) => dispatch((0, scheduledTransactionsActions_1.createScheduledTransaction)(data, { undo: { userMessage: 'Recurring transaction created.' } }));
    const dispatchUpdateScheduledTransactionAction = (data) => dispatch((0, scheduledTransactionsActions_1.updateScheduledTransaction)(data, { undo: { userMessage: 'Recurring transaction updated.' } }));
    const dispatchDeleteScheduledTransactionAction = (data) => dispatch((0, scheduledTransactionsActions_1.deleteScheduledTransaction)(data, { undo: { userMessage: 'Recurring transaction deleted.' } }));
    const makeDialog = (data) => dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData(data)));
    const initialScheduledTransaction = React.useMemo(() => {
        const schTxn = scheduledTransaction.transaction;
        const frequencyAlias = (0, scheduledTransactionsUtils_1.frequencyAliasFromRecurrence)(scheduledTransaction.recurrence);
        const dueOnDate = luxon_1.DateTime.fromISO(scheduledTransaction.dueOn);
        const endOnDate = scheduledTransaction.recurrence && luxon_1.DateTime.fromISO(scheduledTransaction.recurrence.endOn);
        const virtualEndOn = endOnDate && endOnDate.isValid ? endOnDate.toLocaleString(luxon_1.DateTime.DATE_SHORT) : 'Never';
        const negator = (0, scheduledTransactionsUtils_1.negatorFromType)(scheduledTransaction.type);
        const virtualShowSign = Math.sign((schTxn === null || schTxn === void 0 ? void 0 : schTxn.amount) || -1) !== negator ? AmountField_1.ShowSignEnum.ALWAYS : AmountField_1.ShowSignEnum.NEVER;
        const amount = schTxn && !Number.isNaN(schTxn.amount) ? String(negator < 0 ? Math.abs(schTxn.amount) : schTxn.amount) : undefined;
        const immutableTags = schTxn && schTxn.tags ? (0, immutable_1.List)(schTxn.tags) : undefined;
        const items = schTxn && schTxn.split && schTxn.split.items && schTxn.split.items.map((x) => (Object.assign(Object.assign({}, x), { amount: String(x.amount), tags: (0, immutable_1.List)(x.tags) })));
        return Object.assign(Object.assign({ type: (selectedTab && scheduledTransactionsTypes_1.STTypeEnum[selectedTab]) || '' }, scheduledTransaction), { dueOn: dueOnDate && dueOnDate.isValid ? dueOnDate.toLocaleString(luxon_1.DateTime.DATE_SHORT) : '', transaction: Object.assign(Object.assign({ payee: '', accountId: undefined, coa: undefined }, schTxn), { split: {
                    items,
                }, tags: immutableTags, amount }), virtualRecurrence: Object.assign(Object.assign({}, scheduledTransaction.recurrence), { endOn: virtualEndOn }), virtualFrequency: frequencyAlias, virtualShowSign,
            virtualEndOn, virtualAmount: (0, utils_2.setVirtualAmount)(scheduledTransaction, amount) });
    }, [scheduledTransaction, selectedTab]);
    let type = initialScheduledTransaction === null || initialScheduledTransaction === void 0 ? void 0 : initialScheduledTransaction.type;
    const { transaction } = initialScheduledTransaction;
    const [state, setState] = React.useState({
        stateScheduledTxn: initialScheduledTransaction,
        splitViewOpen: Boolean(transaction.split && transaction.split.items && transaction.split.items.length !== 0),
    });
    const { stateScheduledTxn, splitViewOpen } = state;
    const frequencyAliasItems = showScheduledTxnDayFrequency && isQWinDataset
        ? scheduledTransactionsUtils_1.frequencyAliases
        : scheduledTransactionsUtils_1.frequencyAliases.filter((freqAlias) => freqAlias !== scheduledTransactionsUtils_1.frequencyAliasTypes.dayQuicken);
    const isTypeGrossPaycheck = type === 'GROSS_PAYCHECK';
    const deleteSchTxn = (clientId, id, payee) => () => {
        makeDialog({
            id: 'delete-schedule-transaction-confirmation-details',
            type: ConfirmationDialog_1.DIALOG_TYPE,
            props: (0, immutable_1.Map)((0, ConfirmationDialog_1.mkConfirmationDialogProps)({
                title: 'Delete Schedule Transaction',
                content: `Are you sure you want to delete the schedule transaction for "${payee || ''}"?`,
                confirmLabel: 'Delete Schedule Transaction',
                confirmAction: (_reason, _closeEvent) => {
                    dispatchDeleteScheduledTransactionAction((0, scheduledTransactionsTypes_1.mkScheduledTransaction)({
                        clientId,
                        id,
                        isDeleted: true,
                    }));
                    if (onClose) {
                        onClose();
                    }
                },
                denyLabel: 'Go Back',
            })),
        });
    };
    return (<>
      <RendersCount_1.default id={'scheduledTxnForm'}/>
      <formik_1.Formik initialValues={stateScheduledTxn} validateOnChange onSubmit={(values, actions) => {
            var _a, _b;
            const dueOnDate = values.dueOn && luxon_1.DateTime.fromFormat(values.dueOn, utils_2.US_DATE_FORMAT);
            const dueOn = dueOnDate && dueOnDate.isValid ? dueOnDate.toFormat(utils_2.ISO_DATE_FORMAT) : undefined;
            const endOnDate = values.virtualEndOn && luxon_1.DateTime.fromFormat(values.virtualEndOn, utils_2.US_DATE_FORMAT);
            const endOn = endOnDate && endOnDate.isValid ? endOnDate.toFormat(utils_2.ISO_DATE_FORMAT) : '';
            const negator = (0, scheduledTransactionsUtils_1.negatorFromType)(values.type);
            const amount = (values.transaction.amount.includes('+') || values.transaction.amount.includes('-')) ? Number(values.transaction.amount) : Number(values.transaction.amount) * negator;
            const recurrence = values.virtualFrequency === scheduledTransactionsUtils_1.frequencyAliasTypes.custom ? Object.assign(Object.assign({}, stateScheduledTxn.recurrence), { endOn }) : Object.assign(Object.assign({}, values.virtualRecurrence), { endOn });
            // QWIN needs clientId for split Items
            if (transactions_1.transactionsUtils.isSplitTxn(values.transaction)) {
                // eslint-disable-next-line no-param-reassign
                values.transaction.split.items = (_b = (_a = values.transaction.split) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.filter((splitItem) => splitItem.coa.id !== '0' && Number(splitItem.amount) !== 0).map((spliItem) => (Object.assign(Object.assign({}, spliItem), (!spliItem.id && !spliItem.clientId ? { clientId: (0, uuid_1.v4)().toUpperCase() } : {}))));
            }
            const split = (values.transaction.split && values.transaction.split.items)
                ? (0, transactionsTransformers_1.mkSplit)(values.transaction.split)
                : (0, immutable_1.Map)({ items: [] });
            const txns = new transactions_1.transactionsTypes.CashFlowTransaction(Object.assign(Object.assign({}, values.transaction), { split, amount }));
            const data = (0, scheduledTransactionsTypes_1.mkScheduledTransaction)(Object.assign(Object.assign({}, (deleteUserVerificationFromPayload && values.id ?
                (0, lodash_1.omit)(values, ['isUserVerified']) : Object.assign(Object.assign({}, values), { isUserVerified: true }))), { dueOn, overrideNextDueOn: dueOn, overrideNextAmount: amount, recurrence: (0, scheduledTransactionsUtils_1.createValidRecurrence)(recurrence), transaction: (0, utils_1.updateNewTags)(txns, true) }));
            if (values.id) {
                dispatchUpdateScheduledTransactionAction(data);
            }
            else {
                dispatchCreateScheduledTransactionAction(data);
            }
            actions.setSubmitting(false);
            if (changeDetailsMode) {
                changeDetailsMode();
            }
            else {
                onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(data);
                onClose();
            }
            setDirtyForm === null || setDirtyForm === void 0 ? void 0 : setDirtyForm(false);
        }}>
        {(formikProps) => {
            setDirtyForm === null || setDirtyForm === void 0 ? void 0 : setDirtyForm(formikProps.dirty);
            const { values: { dueOn, virtualFrequency, virtualRecurrence } } = formikProps;
            const setNewVirtualRecurrence = ({ dueOnValue, overrideVirtualFreq, overwriteIntervalFlag = false }) => {
                var _a;
                const newValues = overrideVirtualFreq || { virtualFrequency };
                const { virtualRecurrence: { interval: initialInterval } } = formikProps.initialValues;
                let overwriteInterval = (overwriteIntervalFlag && initialInterval !== virtualRecurrence.interval
                    && utils_2.frequenciesEditableInterval.includes(newValues === null || newValues === void 0 ? void 0 : newValues.virtualFrequency)) ? virtualRecurrence.interval : undefined;
                if (initialInterval && !overwriteInterval) {
                    overwriteInterval = initialInterval;
                }
                let newRecurrence = (0, scheduledTransactionsUtils_1.recurrenceFromFrequencyAlias)(newValues.virtualFrequency, dueOnValue.toFormat(utils_2.ISO_DATE_FORMAT), overwriteInterval);
                const [, dtStart] = (0, scheduledTransactionsUtils_1.getEqualantFrequencyForSpecialCase)(newValues.virtualFrequency, null, dueOnValue.toJSDate());
                const newDueOnValue = luxon_1.DateTime.fromJSDate(new Date(dtStart));
                if (newValues.virtualFrequency === scheduledTransactionsUtils_1.frequencyAliasTypes.twiceAYearQuicken && (newDueOnValue.month + 1) >= 6) {
                    newRecurrence = Object.assign(Object.assign({}, newRecurrence), { byDates: newRecurrence.byDates.reverse() });
                }
                newValues.virtualRecurrence = Object.assign({}, newRecurrence);
                formikProps.setValues(Object.assign(Object.assign(Object.assign({}, formikProps.values), newValues), { virtualEndOn: (_a = newRecurrence === null || newRecurrence === void 0 ? void 0 : newRecurrence.endOn) !== null && _a !== void 0 ? _a : formikProps.values.virtualEndOn, dueOn: newDueOnValue.toFormat('MM/dd/yyyy') }));
            };
            return (<formik_1.Form onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        if (showConfirmationDialog) {
                            showConfirmationDialog(false);
                            if (onClose) {
                                onClose();
                            }
                        }
                        if (formikProps.dirty) {
                            showConfirmationDialog(true);
                        }
                        else if (onClose) {
                            onClose();
                        }
                    }
                }}>
              <section className={(0, classnames_1.default)(classes.formSection, classes.headerSection)}>
                <div className={classes.headerSpace}>
                  {label && <Typography_1.default variant="overline" className={classes.labelSpace}>{label}</Typography_1.default>}
                  {showCloseButton && (<IconButton_1.default aria-label="close series properties" onClick={() => {
                        if (formikProps.dirty) {
                            showConfirmationDialog(true);
                        }
                        else if (onClose) {
                            onClose();
                        }
                    }} style={{ padding: 0 }} size="large">
                      <Close_1.default />
                    </IconButton_1.default>)}
                </div>

                <formik_1.Field name="transaction.payee" validate={(value) => value && value.length > 0 ? undefined : 'required'}>
                  {({ field, form: { touched, errors } }) => (<TextField_1.default {...field} id="payee" label="Name" placeholder="Name" error={Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name))} helperText={(0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)} InputProps={{
                        classes: {
                            root: classes.payeeInput,
                            underline: classes.underlineOverride,
                        },
                        autoComplete: 'off',
                    }} margin="dense" fullWidth/>)}
                </formik_1.Field>

                <Grid_1.default container>
                  <Grid_1.default item xs={6} md lg className={classes.inputLeft}>
                    <RecrAmountField_1.default classes={classes} name="transaction.amount" formikProps={formikProps} isTypeGrossPaycheck={isTypeGrossPaycheck}/>
                  </Grid_1.default>

                  <Grid_1.default item xs={6} md lg className={classes.inputRight}>
                    <formik_1.Field name="virtualFrequency" validate={(value) => value && value.length > 0 ? undefined : 'required'}>
                      {(_a) => {
                    var field = __rest(_a.field, []), { form: { values, touched, errors } } = _a;
                    return (<DownshiftField_1.default key={(0, lodash_1.get)(values, field.name)} initialItemSelected={(0, lodash_1.get)(values, field.name)} onSelected={(frequencyAlias) => {
                            const dueOnValue = luxon_1.DateTime.now();
                            formikProps.setFieldValue(field.name, frequencyAlias);
                            setNewVirtualRecurrence({ dueOnValue, overrideVirtualFreq: { [field.name]: frequencyAlias } });
                        }} items={frequencyAliasItems} textFieldProps={{
                            InputProps: Object.assign(Object.assign({}, field), { classes: { underline: classes.underlineOverride }, disabled: isTypeGrossPaycheck }),
                            id: 'frequency',
                            label: 'Frequency',
                            margin: 'normal',
                            fullWidth: true,
                            autoComplete: 'off',
                            error: Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)),
                            helperText: (0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name),
                        }} lightWeight/>);
                }}
                    </formik_1.Field>
                  </Grid_1.default>
                </Grid_1.default>
                {virtualRecurrence && (<RecrVirtualField_1.default classes={classes} virtualFrequency={virtualFrequency} virtualRecurrence={virtualRecurrence} dueOnValue={dueOn} formikProps={formikProps} setNewVirtualRecurrence={setNewVirtualRecurrence} isTypeGrossPaycheck={isTypeGrossPaycheck} monthsIntervalMap={utils_2.monthsIntervalMap} isQWinDataset={isQWinDataset}/>)}
              </section>

              <section className={classes.formSection}>
                <formik_1.Field name="transaction.accountId" validate={(value) => value && value.length > 0 ? undefined : 'required'}>
                  {(_a) => {
                    var field = __rest(_a.field, []), { form: { values, touched, errors } } = _a;
                    return (<AccountField_1.default key={(0, lodash_1.get)(values, field.name)} onSelected={(account) => formikProps.setFieldValue(field.name, account ? account.id : undefined)} initialAccountId={(0, lodash_1.get)(values, field.name)} id="account" label={formikProps.values.type === scheduledTransactionsTypes_1.STTypeEnum.INCOME
                            ? 'Deposit to'
                            : 'Pay from'} margin="normal" autoComplete="off" fullWidth error={Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name))} helperText={(0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)} InputProps={Object.assign(Object.assign({}, field), { classes: { underline: classes.underlineOverride }, disabled: isTypeGrossPaycheck })}/>);
                }}
                </formik_1.Field>
                <formik_1.Field name="type" validate={(value) => value && value.length > 0 ? undefined : 'required'}>
                  {(_a) => {
                    var field = __rest(_a.field, []), { form: { values, touched, errors } } = _a;
                    return (<DownshiftField_1.default key={(0, lodash_1.get)(values, field.name)} initialItemSelected={field.value} onSelected={(txnType) => {
                            formikProps.setFieldValue(field.name, txnType);
                            type = txnType;
                            if (touched && touched.transaction && !touched.transaction.isExcludedFromReports) {
                                formikProps.setFieldValue('transaction.isExcludedFromReports', txnType === scheduledTransactionsTypes_1.STTypeEnum.TRANSFER);
                            }
                            switch (txnType) {
                                case scheduledTransactionsTypes_1.STTypeEnum.INCOME:
                                    if (personalIncomeCategory) {
                                        formikProps.setFieldValue('transaction.coa', { id: personalIncomeCategory.id, type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY }); // personal income
                                    }
                                    else {
                                        formikProps.setFieldValue('transaction.coa', { id: '0', type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.UNCATEGORIZED }); // Uncategorized
                                    }
                                    break;
                                case scheduledTransactionsTypes_1.STTypeEnum.TRANSFER:
                                    formikProps.setFieldValue('transaction.coa', { id: '2', type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.BALANCE_ADJUSTMENT }); // Transfer
                                    break;
                                case scheduledTransactionsTypes_1.STTypeEnum.BILL:
                                case scheduledTransactionsTypes_1.STTypeEnum.SUBSCRIPTION:
                                case scheduledTransactionsTypes_1.STTypeEnum.EXPENSE:
                                default:
                                    formikProps.setFieldValue('transaction.coa', { id: '0', type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.UNCATEGORIZED }); // Uncategorized
                                    break;
                            }
                        }} items={scheduledTransactionsUtils_1.stTypes} itemToString={(item) => scheduledTransactionsUtils_1.STTypeNamesEnum[item] || item} textFieldProps={{
                            InputProps: Object.assign(Object.assign({}, field), { classes: { underline: classes.underlineOverride }, disabled: isTypeGrossPaycheck }),
                            id: 'type',
                            label: 'Type',
                            margin: 'normal',
                            autoComplete: 'off',
                            fullWidth: true,
                            error: Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)),
                            helperText: (0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name),
                        }} lightWeight/>);
                }}
                </formik_1.Field>

                <Grid_1.default container alignItems="center">
                  <Grid_1.default item xs={6} md lg className={(0, classnames_1.default)({ [classes.inputLeft]: !splitViewOpen })}>
                    {(splitViewOpen || (formikProps.values.transaction.split.items && formikProps.values.transaction.split.items.length !== 0))
                    ? (<TextField_1.default label={formikProps.values.type === scheduledTransactionsTypes_1.STTypeEnum.TRANSFER ? 'Account' : 'Category'} value={constants_1.APP_STRING_SPLIT} margin="dense" fullWidth InputProps={{
                            readOnly: true,
                            disabled: true,
                            classes: {
                                underline: classes.underlineOverride,
                                disabled: classes.defaultOverride,
                            },
                        }}/>) : (<RecrCategoryField_1.default name="transaction.coa" formikProps={formikProps} classes={classes}/>)}
                  </Grid_1.default>
                  {!splitViewOpen &&
                    <Grid_1.default item md className={classes.inputRight}>
                      <div>
                        <FormControlLabel_1.default label={<><CallSplit_1.default />Split</>} labelPlacement="start" control={<Switch_1.default color="primary" checked={splitViewOpen} value={splitViewOpen} id="split-switch" onChange={() => {
                                formikProps.setFieldValue('transaction.split.items', []);
                                // this.setState({ splitViewOpen: !splitViewOpen });
                                setState(Object.assign(Object.assign({}, state), { splitViewOpen: !splitViewOpen }));
                            }}/>}/>
                      </div>
                    </Grid_1.default>}
                </Grid_1.default>

                {splitViewOpen &&
                    <div className={classes.mainSplitTxnsContainer}>
                    <SplitsAndDetailsPanel_1.default txn={new transactions_1.transactionsTypes.CashFlowTransaction(Object.assign(Object.assign({}, formikProps.values.transaction), { amount: formikProps.values.virtualAmount, type: formikProps.values.type }))} closeFn={() => setState(Object.assign(Object.assign({}, state), { splitViewOpen: !splitViewOpen }))} splitSwitch={() => setState(Object.assign(Object.assign({}, state), { splitViewOpen: !splitViewOpen }))} onAmountChange={(amount) => {
                            formikProps.setFieldValue('transaction.amount', Math.abs(amount));
                            formikProps.setFieldValue('virtualAmount', (0, utils_2.setVirtualAmount)(formikProps.values, amount));
                        }} saveFn={(txnform) => {
                            var _a;
                            formikProps.setFieldValue('transaction.split.items', ((_a = txnform === null || txnform === void 0 ? void 0 : txnform.split) === null || _a === void 0 ? void 0 : _a.items) || null);
                            formikProps.setFieldValue('transaction.coa', txnform.coa);
                        }} onChangeTxnState={({ split }) => formikProps.setFieldValue('transaction.split.items', split.items)} hideFooter showCurrencySymbol showDetails={false} showSplits={splitViewOpen} forceAutoSave editable={!isTypeGrossPaycheck}/>
                  </div>}
                <Grid_1.default container>
                  <Grid_1.default item xs={6} md lg className={(0, classnames_1.default)({
                    [classes.inputLeft]: virtualFrequency !== scheduledTransactionsUtils_1.frequencyAliasTypes.onlyOnce,
                })}>
                    <formik_1.Field name="dueOn" validate={(value) => {
                    let errorMessage;
                    if (!value || !value.length) {
                        errorMessage = 'required';
                    }
                    else if (!luxon_1.DateTime.fromFormat(value, utils_2.US_DATE_FORMAT).isValid) {
                        errorMessage = 'invalid';
                    }
                    return errorMessage;
                }}>
                      {({ field, form: { values, touched, errors } }) => {
                    const date = luxon_1.DateTime.fromFormat(field.value, utils_2.US_DATE_FORMAT);
                    const selected = date.isValid ? date : luxon_1.DateTime.local();
                    return (<div className={classes.datePickerWrapper}>
                            <react_datepicker_1.default id="next-date" selected={selected.toJSDate()} popperPlacement={!changeDetailsMode ? 'top-start' : 'bottom'} onChange={(jsDate, e) => {
                            const dueOnValue = (e.key ? date : luxon_1.DateTime.fromJSDate(new Date(jsDate)));
                            setNewVirtualRecurrence({ dueOnValue, overwriteIntervalFlag: true });
                        }} onKeyDown={(e) => {
                            if (e.key === 'Escape') {
                                e.stopPropagation();
                            }
                        }} onClickOutside={() => {
                            const dueOnValue = luxon_1.DateTime.fromFormat(dueOn, utils_2.US_DATE_FORMAT);
                            setNewVirtualRecurrence({ dueOnValue, overwriteIntervalFlag: true });
                        }} minDate={luxon_1.DateTime.local().toJSDate()} maxDate={luxon_1.DateTime.fromFormat(values.virtualEndOn, utils_2.US_DATE_FORMAT).toJSDate()} 
                    // dateFormat="MM/DD/YYYY"
                    allowSameDay disabledKeyboardNavigation customInputRef="inputRef" customInput={<TextField_1.default InputProps={Object.assign(Object.assign({}, field), { classes: { underline: classes.underlineOverride }, autoComplete: 'off' })} InputLabelProps={{
                                classes: { root: classes.ellipser },
                            }} label="Recurrence Date" margin="dense" fullWidth error={Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name))} helperText={(0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)}/>}/>
                          </div>);
                }}
                    </formik_1.Field>
                  </Grid_1.default>
                  {virtualFrequency !== scheduledTransactionsUtils_1.frequencyAliasTypes.onlyOnce &&
                    <Grid_1.default item xs={6} md lg className={classes.inputRight}>
                      <formik_1.Field name="virtualEndOn" validate={(value) => value === 'Never' || value === '' || luxon_1.DateTime.fromFormat(value, utils_2.US_DATE_FORMAT).isValid ? undefined : 'invalid'}>
                        {({ field, form: { values, touched, errors } }) => {
                            const date = luxon_1.DateTime.fromFormat(field.value, utils_2.US_DATE_FORMAT);
                            const selected = date.isValid ? date : luxon_1.DateTime.local();
                            return (<div className={classes.datePickerWrapper}>
                              <react_datepicker_1.default id="end-date" selected={selected.toJSDate()} popperPlacement={!changeDetailsMode ? 'top-end' : 'bottom'} onChange={(jsDate, e) => formikProps.setFieldValue(field.name, (e.key ? date : luxon_1.DateTime.fromJSDate(new Date(jsDate))).toLocaleString(luxon_1.DateTime.DATE_SHORT))} onKeyDown={(e) => {
                                    if (e.key === 'Escape') {
                                        e.stopPropagation();
                                    }
                                }} minDate={luxon_1.DateTime.fromFormat(values.dueOn, utils_2.US_DATE_FORMAT).toJSDate()} allowSameDay customInputRef="inputRef" customInput={<TextField_1.default InputProps={Object.assign(Object.assign({}, field), { onBlur: (e) => {
                                            if (!field.value) {
                                                formikProps.setFieldValue(field.name, 'Never');
                                            }
                                            field.onBlur(e);
                                        }, classes: { underline: classes.underlineOverride }, autoComplete: 'off' })} label="End Date" margin="dense" fullWidth error={Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name))} helperText={(0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)}/>}/>
                            </div>);
                        }}
                      </formik_1.Field>
                    </Grid_1.default>}
                </Grid_1.default>

                {(splitViewOpen || (formikProps.values.transaction.split.items &&
                    formikProps.values.transaction.split.items.length !== 0))
                    ? (<TextField_1.default label="Tags" value={constants_1.APP_STRING_SPLIT} margin="dense" fullWidth InputProps={{
                            readOnly: true,
                            disabled: true,
                            classes: {
                                underline: classes.underlineOverride,
                                disabled: classes.defaultOverride,
                            },
                        }}/>) : (<RecrTagField_1.default name="transaction.tags" formikProps={formikProps} classes={classes}/>)}
              </section>

              <section className={classes.buttonsSection}>
                <Grid_1.default container direction="row" justifyContent={hideDeleteIcon ? 'flex-end' : 'space-between'} alignItems="center" spacing={0}>
                  {!hideDeleteIcon && (<Grid_1.default item>
                      <QButton_1.default disabled={!formikProps.values.id} id="delete-transaction" aria-label="delete" variant="outlined" style={{ width: 36, minWidth: 36, marginRight: 8, backgroundColor: 'transparent' }} onClick={deleteSchTxn(formikProps.values.clientId, formikProps.values.id, formikProps.values.transaction.payee)}>
                        <img src={icon_delete_black_svg_1.default} alt="delete"/>
                      </QButton_1.default>
                    </Grid_1.default>)}
                  <Grid_1.default item>
                    <QButton_1.default id="cancel-transaction" aria-label="cancel" variant="outlined" style={{ marginRight: 15 }} onClick={() => {
                    if (formikProps.dirty) {
                        showConfirmationDialog(true);
                    }
                    else if (changeDetailsMode && formikProps.values.id) {
                        changeDetailsMode();
                    }
                    else {
                        onClose();
                    }
                }}>
                      Cancel
                    </QButton_1.default>
                    <QButton_1.default type="submit" id="submit-transaction" disabled={formikProps.isSubmitting || (formikProps.values.id && !formikProps.dirty)} onClick={(e) => {
                    e.preventDefault();
                    formikProps.submitForm();
                }} variant="contained" width={140}>
                      {stateScheduledTxn.id ? 'Update' : 'Create'}
                    </QButton_1.default>
                  </Grid_1.default>
                </Grid_1.default>

              </section>

              <Dialog_1.default open={isConfirmationDialogOpen && (isFormDirty || formikProps.dirty)} keepMounted onClose={() => {
                    setDirtyForm(formikProps.dirty);
                    showConfirmationDialog(false);
                }}>
                <DialogContent_1.default>
                  <DialogContentText_1.default className={classes.discardText}>
                    Are you sure you want to discard all changes?
                  </DialogContentText_1.default>
                </DialogContent_1.default>
                <DialogActions_1.default>
                  <Button_1.default onClick={() => {
                    setDirtyForm(formikProps.dirty);
                    showConfirmationDialog(false);
                }} color="primary" style={{ marginRight: 14 }}>
                    Go Back
                  </Button_1.default>
                  <QButton_1.default onClick={() => {
                    showConfirmationDialog(false);
                    if (discardCb) {
                        discardCb();
                    }
                    else if (onClose) {
                        onClose();
                    }
                }} variant="contained">
                    Discard
                  </QButton_1.default>
                </DialogActions_1.default>
              </Dialog_1.default>
            </formik_1.Form>);
        }}
      </formik_1.Formik>
    </>);
};
exports.default = ScheduledTransactionFormQuicken;
